let scrollPosition = 0;

export const disableScroll = () => {
    scrollPosition = window.scrollY;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add('disable-scroll');
};

export const enableScroll = () => {
    document.body.classList.remove('disable-scroll');
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
};
